<template>
    <div>
    <el-form label-position="right" label-width="180px" :model="formLabelAlign">
            <el-form-item label="Payment Method">
                <div class="text-details">{{formLabelAlign.payType | paymentMethod}}</div>
            
            </el-form-item>
            <el-form-item label="Payment Date">
                <!-- <el-input :disabled="true" v-model="formLabelAlign.paidAt.date"></el-input> -->
                <div v-if="formLabelAlign.paidAt" class="text-details">{{formLabelAlign.paidAt.date | formatDate }}</div>
            </el-form-item>
            <el-form-item label="Payment ID">
                <!-- <el-input :disabled="true" v-model="formLabelAlign.paymentId"></el-input> -->
                <div class="text-details">{{formLabelAlign.paymentId}}</div>
            </el-form-item>
            <el-form-item label="Transaction ID">
                <!-- <el-input :disabled="true" v-model="formLabelAlign.paymentId"></el-input> -->
                <div class="text-details">{{formLabelAlign.transactionId}}</div>
            </el-form-item>
            <el-form-item label="Payment Status">
                <!-- <el-input :disabled="true" v-model="formLabelAlign.status"></el-input> -->
                <div v-if="formLabelAlign.paidAt" class="text-details">{{formLabelAlign.paidAt.date | paymentStatus }}</div>
            </el-form-item>
            <el-form-item label="Receipt Uploaded">
                 <!-- <el-image :disabled="true" :src="formLabelAlign.receiptFile"></el-image> -->
                 <upload :disabled="false" @childByValue="childByValue" :imageurl="formLabelAlign.receiptFile"></upload>
            </el-form-item>
    </el-form>
    </div>
</template>

<script>
    import {uploadReceiptRequests} from '@/api/admin/application'
    import upload from '@/components/upload'
    export default {
        components:{upload},
        props:{
            id:{
               type:Number,
               default:0
            },
            formLabelAlign:{
                type:Object,
                default:function(){}
            }
        },
        methods:{
            childByValue(value){
                this.formLabelAlign.receiptFile = value
                this.uploadReceiptRequests(this.formLabelAlign.receiptFile)
                this.$forceUpdate()
            },
            uploadReceiptRequests(receiptFile){
                let from = {
                    receiptFile:receiptFile
                }
                uploadReceiptRequests(this.id,from).then(()=>{
                   this.$message({
                       message:'Receipt Uploaded',
                       type:'success'
                   })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.text-details{
    min-height: 40px;
    padding: 10px;
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #525252;
    cursor: not-allowed;
    border-radius: 5px;
}
</style>